import React from 'react';
import logo from '../../../../public/asset/images/logo.png';
import LoginForm from './LoginForm';

/**
 * 登录容器组件
 */
const LoginContainer = React.memo(() => {
  return (
    <div className='flex flex-col justify-center items-end h-full'>
      <div className='p-8 sm:p-12 bg-white rounded-2xl flex flex-col items-center w-full sm:w-[420px]'>
        {/* 移动端Logo和标题 */}
        <div className='flex flex-row items-center mb-8'>
          <img 
            className="w-8 h-8 rounded mr-3 block lg:hidden" 
            src={logo} 
            alt="贯石科技Logo"
          />
          <span className='text-2xl text-slate-800 font-bold'>
            欢迎使用贯石综合平台
          </span>
        </div>

        {/* 登录表单 */}
        <LoginForm />
      </div>
    </div>
  );
});

LoginContainer.displayName = 'LoginContainer';

export default LoginContainer;